import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const moneyReceiptApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Get all money receipts
    getAllMoneyReceipts: builder.query({
      query: () => "qwikITMoneyReceipt/",
      providesTags: ["MoneyReceipt"],
      transformResponse: (response) => response.reverse(),
    }),

    // Get single money receipt by ID
    getMoneyReceiptById: builder.query({
      query: (id) => `qwikITMoneyReceipt/${id}`,
      providesTags: ["MoneyReceipt"],
    }),

    // Create new money receipt
    createMoneyReceipt: builder.mutation({
      query: (data) => ({
        url: "qwikITMoneyReceipt/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MoneyReceipt"],
      transformResponse: (response) => {
        toast.success("Money receipt saved successfully");
        return response;
      },
    }),

    // Update money receipt
    updateMoneyReceipt: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITMoneyReceipt/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["MoneyReceipt"],
      transformResponse: (response) => {
        toast.success("Money receipt updated successfully");
        return response;
      },
    }),

    // Delete money receipt
    deleteMoneyReceipt: builder.mutation({
      query: (id) => ({
        url: `qwikITMoneyReceipt/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["MoneyReceipt"],
      transformResponse: (response) => {
        toast.success("Money receipt deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllMoneyReceiptsQuery,
  useGetMoneyReceiptByIdQuery,
  useCreateMoneyReceiptMutation,
  useUpdateMoneyReceiptMutation,
  useDeleteMoneyReceiptMutation,
} = moneyReceiptApi;